import { __decorate, __metadata } from "tslib";
import { AppEnvironment } from '@ho/shared/data-access/core/app-environment.model';
import { Inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ALL_PERMISSIONS } from '@ho/tools/constants';
let SessionApiService = class SessionApiService {
    constructor(_http, _environment) {
        this._http = _http;
        this._environment = _environment;
    }
    login(credentials) {
        return this._http.post('/login', credentials);
    }
    logout() {
        return this._http.post('/logout', null);
    }
    currentUserInfo() {
        return this._http.get(`/me/`);
    }
    myPermissions() {
        return of(ALL_PERMISSIONS); //this._http.get<IRestResponse<string[]>>(`/rbac/my-permissions`);
    }
};
SessionApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [AppEnvironment,] }] }
];
SessionApiService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClient, Object])
], SessionApiService);
export { SessionApiService };
